import { RootState } from '../redux';

export const selectFinancialData = (state: RootState) => state.financialData;
export const selectIsUploadLoadingFinancialData = (state: RootState) => state.financialData.isUploadLoading;
